import React from 'react';
import PropTypes from 'prop-types';

import SearchMeta from 'app/utility/search-meta';
import SearchPager from 'app/utility/search-pager';
import ProviderSurgeIncentiveSearchTable from './provider-surge-incentive-search-table';

const ProviderSurgeIncentiveSearchResults = ({
  surgeIncentives,
  page,
  perPage,
  totalEntries,
  loading,
  changePage
}) => (
  <div>
    <SearchMeta totalEntries={totalEntries} returned={surgeIncentives.length} loading={loading} />
    <SearchPager page={page} totalEntries={totalEntries} setPage={changePage} perPage={perPage} />
    <ProviderSurgeIncentiveSearchTable surgeIncentives={surgeIncentives} />
    <SearchPager page={page} totalEntries={totalEntries} setPage={changePage} perPage={perPage} />
  </div>
);

ProviderSurgeIncentiveSearchResults.propTypes = {
  surgeIncentives: PropTypes.array.isRequired,
  page: PropTypes.number,
  perPage: PropTypes.number,
  totalEntries: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  changePage: PropTypes.func.isRequired
};

export default ProviderSurgeIncentiveSearchResults;
